<template>
  <div>
    <TopNavigation activeApp="Ops Portal Login"/>
    <div class="auth">
      <!--div :toggle='toggle' v-if="formState === 'signUp'">Email Echo Systems For An Account</div-->
      <sign-in v-if="!signedIn"></sign-in>
      <Home v-else />
    </div>
  </div>

</template>

<script>
import SignIn from './SignIn'
// import Home from '../Home'
// import { mapGetters, mapState} from 'vuex'
import { mapState} from 'vuex'
import TopNavigation from '@/components/TopNavigation.vue'


export default {
  name: 'auth',
  components: {
    // Home,
    SignIn,
    TopNavigation
  },
  data() {
    return {
      formState: 'signIn'
    }
  },
  created(){
    //this comes into play if the user is sign in to multiple tabs and has logged out in one of them.
    //then we ensue that the authstore is cleared too.
    if (!this.signedIn){
      this.$store.dispatch('authstore/setUser', undefined)
    }
  },
  methods: {
  },
  computed: {
    ...mapState({
    signedIn: state => state.authstore.userSignedIn
    }),
  }
}
</script>

<style>
.auth {
  margin: 0 auto;
  width: 360px;
}
.toggle {
  cursor: pointer;
  font-size: 18px;
}
</style>